"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showOnMobile = exports.hideOnMobile = exports.onDesktop = exports.onMobile = void 0;
const styled_components_1 = require("styled-components");
exports.onMobile = (0, styled_components_1.css) `
  (max-width: ${({ theme }) => theme.breakpoint.tablet})
`;
exports.onDesktop = (0, styled_components_1.css) `
  (min-width: ${({ theme }) => theme.breakpoint.tablet})
`;
exports.hideOnMobile = (0, styled_components_1.css) `
  @media ${exports.onMobile} {
    display: none;
  }
`;
exports.showOnMobile = (0, styled_components_1.css) `
  @media ${exports.onDesktop} {
    display: none;
  }
`;
